<h2 mat-dialog-title>
  <mat-icon color="primary">email</mat-icon>
  Test de Envío de Email
</h2>

<ngx-spinner name="spinerEmail" bdColor="rgba(255,255,255,0.8)" size="default" color="#009688" type="ball-atom"
  [fullScreen]="false">
</ngx-spinner>

<form [formGroup]="form" (ngSubmit)="enviar()">
  <mat-dialog-content>

    <mat-form-field class="full-width" appearance="outline">
      <mat-label>Destinatarios</mat-label>
      <input matInput formControlName="destinatarios" placeholder="email1@ejemplo.com, email2@ejemplo.com">
      <mat-hint>Separar múltiples emails con coma</mat-hint>
      <mat-error *ngIf="destinatariosCtrl.errors?.required">Campo requerido</mat-error>
    </mat-form-field>

    <mat-form-field class="full-width" appearance="outline">
      <mat-label>Asunto</mat-label>
      <input matInput formControlName="asunto">
      <mat-error *ngIf="asunto.errors?.required">Campo requerido</mat-error>
    </mat-form-field>

    <mat-form-field class="full-width" appearance="outline">
      <mat-label>Mensaje</mat-label>
      <textarea matInput formControlName="body" rows="6"></textarea>
      <mat-error *ngIf="body.errors?.required">Campo requerido</mat-error>
    </mat-form-field>

  </mat-dialog-content>

  <mat-dialog-actions align="end">
    <button mat-button type="button" (click)="cancelar()" [disabled]="enviando">
      Cancelar
    </button>
    <button mat-raised-button color="primary" type="submit" [disabled]="enviando">
      <mat-icon>send</mat-icon>
      {{ enviando ? 'Enviando...' : 'Enviar' }}
    </button>
  </mat-dialog-actions>
</form>
